;(function($){

    function InvoicesToPlay() {
        var _ = this;
        _.API = $("#app_url").val() + "/api/";
        _.oInvoicesToPay     = $("input[name='invoices_to_pay[]']");
        _.total_value        = parseFloat(0);
        _.total_value_paid   = parseFloat(0);
        _.total_value_open   = parseFloat(0);

        $.ajaxSetup({
          headers:{
            'Accept' : "application/json",
            'Authorization': "Bearer "+$('meta[name="app-token"]').attr('content'),
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
          }
        }); 

        $("#invoices-to-pay-legend").on("click", function(e){
            e.preventDefault();
            

            swal({
              type: 'info',
              html:
                '<div style="text-align: left; max-width: 150px; margin: 0 auto;"><i class="fa fa-circle" style="color: #4db300;"></i> Em Aberto </br>' +
                '<i class="fa fa-circle" style="color: #c33434;"></i> Pago </br>' +
                '<i class="fa fa-circle" style="color: #blue;"></i> Pago Parcial </br>',
              showCloseButton: true,
              showCancelButton: false,
              focusConfirm: false,
              confirmButtonColor: '#539e30',
              confirmButtonText:
                'Fechar'
            });
        });       

        if($("#modal-invoice-to-pay-create").length > 0) {
            
            $("#modal-invoice-to-pay-create").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getProviders();
                    _.getCostCenters();
                    _.getFinancialNatures();
                    _.getAccoutingItens();
                    _.getProjectTypes();
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();

                    _.html = '<form id="form-invoice-to-pay-create" enctype="multipart/form-data">' +
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="providers_id">Fornecedor</label>' +
                                '<select name="providers_id" id="providers_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="date_of_issue">Data Emissão</label>' +
                                '<input type="date" id="date_of_issue" name="date_of_issue" value="'+$('meta[name="current-date"]').attr('content')+'">' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="due_date">Data Vencimento</label>' +
                                '<input type="date" id="due_date" name="due_date">' +
                            '</div>'+
                        '</div>'+ 
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="value">Total do Débito</label>' +
                                '<input type="text" id="value" name="value" data="data-money">' +
                            '</div>'+
                        '</div>'+ 
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="plots">Nº de Parcelas</label>' +
                                '<input type="text" id="plots" name="plots" data="data-integrate">' +
                            '</div>'+
                        '</div>'+                        
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="form_of_payment">Metódo de Pagamento</label>' +
                                '<select name="form_of_payment" id="form_of_payment">'+
                                    '<option value="">Selecione</option>'+
                                    '<option value="1" selected>Boleto</option>'+
                                    '<option value="2">Transferência Bancária</option>'+
                                '</select>' +
                            '</div>'+
                        '</div>'+                            
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="number_nf">Nº da Nota Fiscal</label>' +
                                '<input type="text" id="number_nf" name="number_nf">' +
                            '</div>'+
                        '</div>'+                                                  
                   '</div>'+
                   '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                            '<div class="form-row">' +
                                '<label for="costcenters_id">Centro de Custo</label>' +
                                '<select name="costcenter_id" id="costcenters_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                        '<div class="form-row">' +
                            '<label for="financialnatures_id">Natureza Financeiral</label>' +
                            '<select name="financialnature_id" id="financialnatures_id" disabled></select>' +
                        '</div>'+
                        '</div>'+
                    '</div>'+
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                            '<div class="form-row">' +
                                '<label for="accoutingitens_id">Item Contábil</label>' +
                                '<select name="accoutitem_id" id="accoutingitens_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                        '<div class="col-lg-6  col-md-6  col-sm-6 col-xs-6">'+
                            '<div class="form-row">' +
                                '<label for="project_types_id">Projeto</label>' +
                                '<select name="project_type_id" id="project_types_id" disabled></select>' +
                            '</div>'+
                        '</div>'+
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">' +
                            '<div class="form-row">' +
                                '<label for="anex">Arquivo Anexo</label>' +
                                '<input type="file" name="anex" id="anex">' +
                            '</div>' +
                        '</div>' +
                    '</div>' +
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +
                                '<label for="text">Observação</label>' +
                                '<textarea name="text" id="text" rows="5"></textarea>' +
                                '<script src="'+$("#app_url").val()+'/vendor/ckeditor/ckeditor.js"></script>'+
                                 '<script>'+
                                    'CKEDITOR.replace("text", {'+
                                    'toolbarGroups: [{ name: "basicstyles", groups: [ "basicstyles", "cleanup" ] }, { name: "paragraph", groups: [ "list", "indent", "blocks", "align", "bidi", "paragraph" ] }],'+
                                    'height: 130,'+
                                '});'+
                                '</script>' +
                            '</div>'+
                        '</div>'+                            
                   '</div>'+
                    '<div class="row">' +
                        '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                            '<div class="form-row">' +                                                          
                                '<button class="pull-right btn-primary btn-send">Salvar <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                            '</div>'+
                        '</div>'+                             
                   '</div></form>';

                    if(_.html != "") {
                        $('#modal-invoice-to-pay-create').iziModal('setTitle', '<i class="fa fa-money" aria-hidden="true"></i> Criar Titulo');
                        $("#modal-invoice-to-pay-create .content").html(_.html);

                        $(document).find('input[data="data-money"]').mask('000.000.000.000.000,00', {reverse: true});

                        _.myForm = $("#form-invoice-to-pay-create").validate({
                            rules: {
                                providers_id: { required: true },
                                form_of_payment: { required: true },
                                due_date: { required: true },
                                date_of_issue: { required: true },
                                value: { required: true }
                            },
                            messages: {
                                providers_id: { required: "Campo Obrigatório" },
                                schedule_id: { required: "Campo Obrigatório" },
                                due_date: { required: "Campo Obrigatório" },
                                date_of_issue: { required: "Campo Obrigatório" },
                                value: { required: "Campo Obrigatório" }
                            },
                            invalidHandler: function(e) {
                                
                                swal({
                                    title: "Atenção!",
                                    text: "Preencha todos os campos.",
                                    type: "warning",
                                    showCancelButton: false,
                                    confirmButtonColor: "#DD6B55",
                                    confirmButtonText: "OK!",
                                    closeOnConfirm: true
                                });
                            },
                            submitHandler: function( form ) {

                                for(instance in CKEDITOR.instances) {
                                    CKEDITOR.instances[instance].updateElement();
                                }

                                $("#form-invoice-to-pay-create .btn-send").html("Enviando...");
                                
                                $.ajax({
                                    type: "POST",
                                    url: _.API + "contas-a-pagar/titulo/criar",
                                    cache: false,
                                    contentType: false,
                                    processData: false,
                                    data: new FormData(form),
                                    success: function(result)
                                    {
                                        $("#form-invoice-to-pay-create .btn-send").html("Enviar");

                                        form.reset();

                                        $('#modal-invoice-to-pay-create').iziModal('close'); 

                                        swal({
                                            title: result.message,
                                            text: "Click no botão para fechar!",
                                            type: "success",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: false
                                        }).then(function() {
                                          location.reload();
                                        });                                        
                                    },
                                    error: function(response) {
                                        var errors = $.parseJSON(response.responseText);
                                        
                                        swal({
                                            title: (errors.message) ? errors.message : "Ops! Houve um erro ao enviar. Tente novamente.",
                                            text: "Click no botão para fechar!",
                                            type: "warning",
                                            showCancelButton: false,
                                            confirmButtonColor: "#DD6B55",
                                            confirmButtonText: "Fechar!",
                                            closeOnConfirm: true
                                        });

                                        $myForm.showErrors(errors);
                                        
                                        $("#form-invoice-to-pay-create .btn-send").html("Enviar");
                                    }
                                });
                            }
                        });
                    }               
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    _.myForm       = null;
                    $("#modal-invoice-to-pay-create .content").html("");
                    $('#modal-invoice-to-pay-create').iziModal('setTitle', "");
                }        
            });
        }

        if($("#modal-invoice-to-pay-low").length > 0) {

            $("#modal-invoice-to-pay-low").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading();  
                    _.getBanckAccount(); 
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();  
                    _.html = '<form id="form-invoice-to-pay-low">'+
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="bank_account">Banco/Agencia/Conta:</label>' +
                                    '<select name="bank_account" id="bank_account" disabled required></select>' +
                                    '<input type="hidden" id="is_partial" name="is_partial" value="2">' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="pay_day">Data da Baixa:</label>' +
                                    '<input type="date" id="pay_day" name="pay_day" required>' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+  
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<button class="pull-right btn-primary btn-send">OK <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                   '</form>';
                    $('#modal-invoice-to-pay-low').iziModal('setTitle', '<i class="fa fa-money" aria-hidden="true"></i> Paramentros de Baixa');
                    $("#modal-invoice-to-pay-low .content").html(_.html);

                    _.myForm = $("#form-invoice-to-pay-low").validate({
                        rules: {
                            filter_send_billets: { required: true },
                            filter_send_nfse: { required: true }
                        },
                        messages: {
                            filter_send_billets: { required: "Campo Obrigatório" },
                            filter_send_nfse: { required: "Campo Obrigatório" }
                        },
                        invalidHandler: function(e) {
                            swal({
                                title: "Atenção!",
                                text: "Confirme os paramentros",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                            var href             = new URL(_.url);
                            $.each($('#form-invoice-to-pay-low').serializeArray(), function(i, field){  
                               href.searchParams.set(field.name, field.value);   
                            }); 

                            window.location.href = href; 
                        }
                    });             
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    $("#modal-invoice-to-pay-low .content").html("");
                    $('#modal-invoice-to-pay-low').iziModal('setTitle', "");
                    
                }        
            });         
        } 

        if($("#modal-invoice-to-pay-low-partial").length > 0) {

            $("#modal-invoice-to-pay-low-partial").iziModal({      
                bodyOverflow: true,
                closeOnEscape: false,
                overlayClose: false,
                history: false,
                autoOpen: false,
                onOpened: function(){
                    _.modal.stopLoading(); 
                    _.getBanckAccount(); 
                },
                onOpening: function(modal){ 

                    _.modal = modal;

                    modal.startLoading();  
                    _.html = '<form id="form-invoice-to-pay-low-partial">'+
                         '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="bank_account">Banco/Agencia/Conta:</label>' +
                                    '<select name="bank_account" id="bank_account" disabled required></select>' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="value">Valor da Baixa:</label>' +
                                    '<input type="text" id="value" name="value" data="data-money" required>' +
                                     '<input type="hidden" id="is_partial" name="is_partial" value="1">' +
                                '</div>'+
                            '</div>'+                          
                       '</div>'+ 
                        '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<label for="pay_day">Data da Baixa:</label>' +
                                    '<input type="date" id="pay_day" name="pay_day" required>' +
                                '</div>'+
                            '</div>'+                            
                       '</div>'+                        
                       '<div class="row">' +
                            '<div class="col-lg-12  col-md-12  col-sm-12 col-xs-12">'+
                                '<div class="form-row">' +
                                    '<button class="pull-right btn-primary btn-send">OK <i class="fa fa-check-square" aria-hidden="true"></i></button>'+
                                '</div>'+
                            '</div>'+                            
                       '</div>'+
                   '</form>';
                    $('#modal-invoice-to-pay-low-partial').iziModal('setTitle', '<i class="fa fa-money" aria-hidden="true"></i> Paramentros de Baixa Parcial');
                    $("#modal-invoice-to-pay-low-partial .content").html(_.html);

                    $(document).find('input[data="data-money"]').mask('000.000.000.000.000,00', {reverse: true});

                    _.myForm = $("#form-invoice-to-pay-low-partial").validate({
                        rules: {
                            bank_account: { required: true },
                            value: { required: true }
                        },
                        messages: {
                            bank_account: { required: "Campo Obrigatório" },
                            value: { required: "Campo Obrigatório" }
                        },
                        invalidHandler: function(e) {
                            
                            swal({
                                title: "Atenção!",
                                text: "Confirme os paramentros",
                                type: "warning",
                                showCancelButton: false,
                                confirmButtonColor: "#DD6B55",
                                confirmButtonText: "OK!",
                                closeOnConfirm: true
                            });

                        },
                        submitHandler: function( form ) {
                            var href = new URL(_.url);
                            $.each($('#form-invoice-to-pay-low-partial').serializeArray(), function(index, field){  
                                href.searchParams.set(field.name, field.value);  
                            }); 

                            window.location.href = href; 
                        }
                    });             
                },
                onClosed: function() {
                    _.uri          = null;
                    _.html         = null;
                    $("#modal-invoice-to-pay-low-partial .content").html("");
                    $('#modal-invoice-to-pay-low-partial').iziModal('setTitle', "");
                    
                }        
            });         
        }

        $("a.btn-invoice-to-pay-low").on("click", function(e){
            e.preventDefault();
             if (_.preventPaymentForSettledInvoices()) {
                return false;
            }

            _.url           = $(this).attr('href');
            $('#modal-invoice-to-pay-low').iziModal('open');           
        });

        $("a.btn-invoice-to-pay-low-partial").on("click", function(e){
            e.preventDefault();

            if($("input[name='invoices_to_pay[]']:checked").length > 1) {

                swal({
                    title: "Atenção!",
                    text: "Não é possivel a baixa parcial para mais de um titulo.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK!",
                    closeOnConfirm: true
                });

                return false;
            }

            if($("input[name='invoices_to_pay[]']:checked").length == 0) {

                swal({
                    title: "Atenção!",
                    text: "Selecione um titulo.",
                    type: "warning",
                    showCancelButton: false,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "OK!",
                    closeOnConfirm: true
                });

                return false;
            }
             if (_.preventPaymentForSettledInvoices()) {
                return false;
            }


            _.url           = $(this).attr('href');
            $('#modal-invoice-to-pay-low-partial').iziModal('open');           
        });

        $("button.btn-create-invoice-to-pay").on("click", function(e){
            e.preventDefault();
            $('#modal-invoice-to-pay-create').iziModal('open');           
        });

        $("input#invoicesToPayAll").on("change", function(e){
            $(this).is(':checked') ? _.checkAll() : _.UnCheckAll();
        });

        $("input[name='invoices_to_pay[]']").on("change", function(e){

            if($("input[name='invoices_to_pay[]']:checked").length == 0) {
                window.location.reload(true);
            }
            
            _.total(this, $(this).is(':checked'));
        });
    }

    InvoicesToPlay.prototype.getProviders = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/fornecedores", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#providers_id").attr('disabled', false).html(html);
            $("select#providers_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });           
        });
    }; 

    InvoicesToPlay.prototype.getCostCenters = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/centro-de-custo", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#costcenters_id").attr('disabled', false).html(html);
            $("select#costcenters_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

    InvoicesToPlay.prototype.getFinancialNatures = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/natureza-financeira", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#financialnatures_id").attr('disabled', false).html(html);
            $("select#financialnatures_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    };  
     
    InvoicesToPlay.prototype.getAccoutingItens = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/item-contabil", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#accoutingitens_id").attr('disabled', false).html(html);
            $("select#accoutingitens_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 
    
      InvoicesToPlay.prototype.getProjectTypes = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/tipo-de-projeto", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#project_types_id").attr('disabled', false).html(html);
            $("select#project_types_id").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

    InvoicesToPlay.prototype.getBanckAccount = function() {

        var _ =  this;
        
        $.get($("#app_url").val() + "/api/bancos/contas", function( data ) {
          
            var html = '<option value="">Selecione</option>';

            $.each(data, function(index, value) {
               html += '<option value="'+ index +'" >'+ value +'</option>';
            });

            $("select#bank_account").attr('disabled', false).html(html);
            $("select#bank_account").select2({
                placeholder: 'Selecione',
                allowClear: true
            });
        });
    }; 

    InvoicesToPlay.prototype.checkAll = function() {
        var _ =  this;
        _.oInvoicesToPay.each(function( index, value) {
           $(value).prop('checked', true);
           _.total(value, true);
        });
    };

    InvoicesToPlay.prototype.UnCheckAll = function() {
        var _ =  this;

        _.oInvoicesToPay.each(function( index, value) {
           $(value).prop('checked', false);
           window.location.reload(true);
        });
    };

    InvoicesToPlay.prototype.total = function(item, isSum) {
        var _                 = this;
        var ntotal_value      = 0;
        var ntotal_value_paid = 0;
        var ntotal_value_open = 0;
        var a_invoices_to_pay = [];

        if (isSum) {
            _.total_value      += parseFloat($(item).data('total'));
            _.total_value_paid += parseFloat($(item).data('paid-total'));
            _.total_value_open += parseFloat($(item).data('opened-total'));
        } else {
            _.total_value      -= parseFloat($(item).data('total'));
            _.total_value_paid -= parseFloat($(item).data('paid-total'));
            _.total_value_open -= parseFloat($(item).data('opened-total'));
        }


        ntotal_value      = _.total_value;
        ntotal_value_paid = _.total_value_paid;
        ntotal_value_open = _.total_value_open;


        ntotal_value      =  ntotal_value.toFixed(2);
        ntotal_value_paid =  ntotal_value_paid.toFixed(2);
        ntotal_value_open =  ntotal_value_open.toFixed(2);

        ntotal_value      =  ntotal_value.replace('.',',');
        ntotal_value_paid =  ntotal_value_paid.replace('.',',');
        ntotal_value_open =  ntotal_value_open.replace('.',',');


        $(".title-total-value").text(ntotal_value);        
        $(".title-total-value-paid").text(ntotal_value_paid);
        $(".title-total-value-open").text(ntotal_value_open);

        $.each($("input[name='invoices_to_pay[]']:checked"), function(idex, value) {
            a_invoices_to_pay.push($(value).val());
        }); 

        $.each($("#links a"), function(idex, value) {
            var href  = new URL($(value).attr('href'));
            href.searchParams.set('a_invoices_to_pay', a_invoices_to_pay);
            $(value).attr('href', href);
        });        
    };
     InvoicesToPlay.prototype.getSettledInvoices = function() {
        var settled = [];

        $.each($("input[name='invoices_to_pay[]']:checked"), function(index, item) {
            var $item = $(item);
            var status = String($item.data('status'));
            var balance = parseFloat($item.data('opened-total'));

            if (status === "1" && !isNaN(balance) && balance <= 0) {
                settled.push({
                    id: $item.val(),
                    payday: $item.data('payday')
                });
            }
        });

        return settled;
    };

    InvoicesToPlay.prototype.preventPaymentForSettledInvoices = function() {
        var settled = this.getSettledInvoices();

        if (settled.length === 0) {
            return false;
        }

        var first = settled[0];
        var msg = "O título " + first.id + " já está pago e com saldo zerado.";

        if (first.payday) {
            msg += " Data da baixa: " + first.payday + ".";
        }

        if (settled.length > 1) {
            msg += " Há mais títulos selecionados nessa condição.";
        }

        swal({
            title: "Atenção!",
            text: msg,
            type: "warning",
            showCancelButton: false,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: "OK!",
            closeOnConfirm: true
        });

        return true;
    };

   	new InvoicesToPlay();

}(jQuery));
 
 
 
 
